import { api } from './api';

export interface TopicScheduleEntry {
  id: number;
  courseId: number;
  nodeId: number;
  targetDate: string;
  createdAt?: string;
}

export const listSchedules = async (courseId: number): Promise<TopicScheduleEntry[]> => {
  const response = await api.get(`/api/tutor/courses/${courseId}/schedule`);
  return response.data.data;
};

export const upsertSchedule = async (courseId: number, nodeId: number, targetDate: string): Promise<TopicScheduleEntry> => {
  const response = await api.put(`/api/tutor/courses/${courseId}/schedule/${nodeId}`, { targetDate });
  return response.data.data;
};

export const deleteSchedule = async (courseId: number, nodeId: number): Promise<void> => {
  await api.delete(`/api/tutor/courses/${courseId}/schedule/${nodeId}`);
};
